export default "__VITE_ASSET__D74CgDLJ__"